<template>
	<LabeledObject>
		<template #label>{{ trans('rotations.elections.candidates.student_group_participation') }}</template>
		<p v-if="candidate.student_group_participation" class="text-red-700">{{ trans('general.yes') }}</p>
		<p v-else class="text-green-700">{{ trans('general.no') }}</p>
	</LabeledObject>
	<LabeledObject v-if="candidate.student_group_description">
		<template #label>{{ trans('rotations.elections.candidates.student_group_description') }}</template>
		<p>{{ candidate.student_group_description }}</p>
	</LabeledObject>
	<LabeledObject>
		<template #label>{{ trans('rotations.elections.candidates.student_council_participation') }}</template>
		<ParticipationAnswer :answer="candidate.student_council_participation"/>
		<template v-if="candidate.student_council_participation === RotationCandidateParticipation.won">
			<p v-if="candidate.student_council_resignation" class="text-green-700">{{ trans('rotations.elections.candidates.student_council_resignation_options.resigned') }}</p>
			<p v-else class="text-red-700">{{ trans('rotations.elections.candidates.student_council_resignation_options.not_resigned') }}</p>
		</template>
	</LabeledObject>
	<LabeledObject>
		<template #label>{{ trans('rotations.elections.candidates.counseling_participation') }}</template>
		<ParticipationAnswer :answer="candidate.counseling_participation"/>
	</LabeledObject>
	<LabeledObject>
		<template #label>{{ trans('rotations.elections.candidates.reasons') }}</template>
		<p>{{ candidate.reasons }}</p>
	</LabeledObject>
	<LabeledObject v-if="candidate.observations">
		<template #label>{{ trans('rotations.elections.candidates.observations') }}</template>
		<p>{{ candidate.observations }}</p>
	</LabeledObject>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'
import {trans} from 'laravel-vue-i18n'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {type RotationCandidate} from '@/Types/Periods/Rotations/RotationCandidate'
import ParticipationAnswer from '@/Components/Periods/Rotations/ParticipationAnswer.vue'
import {RotationCandidateParticipation} from '@/Types/Enums/RotationCandidateParticipation'

defineProps<{
	candidate:RotationCandidate,
}>()
</script>
